<template>
  <div class="wrapper">
    <div class="news_box">
      <scroll
        class="wrapper"
        :data="dataList"
        :allLoaded="allLoaded"
        @pulldown="loadData"
        @loadUp="loadup"
        v-if="dataList.length"
      >
        <div
          class="list_item"
          v-for="(item,index) in dataList"
          :key="index"
          @click="toDetail(item.orderId)"
        >
          <section class="item_top">
            <p class="item_top_left">预约时间:{{item.orderTime}}</p>
            <span :class="['item_top_right',(item.status==2 || item.status== 1 || item.status==5 || item.status ==8 ||item.status==3)?'item_top_right_un':'']">{{item.status | statusText}}</span>
          </section>
          <section class="item_center" v-if="item.roomNo">
            <p>单元号:{{item.roomNo}}</p>
          </section>
          <section class="item_bottom">
            <p class="item_bottom_left">{{item.createTime | timeT}}</p>
            <p class="item_bottom_right" v-if="(item.status == 2 || item.status==5 || item.status==8 || item.status==9 || item.status==10) && item.totalPrice">实付: ¥{{item.totalPrice}}</p>
            <p class="item_bottom_right gray" v-if="(item.status == 0) && item.totalPrice">¥{{item.totalPrice}}</p>
          </section>
        </div>
      </scroll>
      <no-message v-if="dataList.length == 0 && loaded"></no-message>
    </div>
  </div>
</template>

<script>
import Scroll from "../../components/scroll";
import NoMessage from "../../components/nomessage";
import util from "../../utils/util";
import { getIntServOrderList } from "../../utils/api";
import { mapState } from "vuex";

export default {
  name: "myAppoint",
  components: {
    Scroll,
    NoMessage
  },
  data() {
    return {
      pageNo: 1,
      type: 0,
      allLoaded: false,
      loaded: false,
      dataList: []
    };
  },
  filters: {
    timeT(val) {
      return util.formatTime(new Date(val), 10);
    },
    statusText(val) {
      // ，0待支付,1已取消，2已支付，3已超时，4已退款，5已完成  6待受理 7已派单 8已评价
      let text = "";
      switch (val) {
        case "0":
          text = "确认费用";
          break;
        case "1":
          text = "已取消";
          break;
        case "2":
          text = "已支付";
          break;
        case "3":
          text = "已超时";
          break;
        case "4":
          text = "已退款";
          break;
        case "5":
          text = "已完成";
          break;
        case "6":
          text = "已预约";
          break;
        case "7":
          text = "已受理";
          break;
        case "8":
          text = "已评价";
          break;
        case "9":
          text = "待服务";
          break;
        case "10":
          text = "已服务";
          break;
        default:
          text = "已预约";
      }
      return text;
    }
  },
  computed: {
    ...mapState({
      common: state => state.common,
      openId: state => state.common.openId,
      userId: state => state.common.userId
    })
  },
  activated() {
    this.getIntServOrderList();
  },
  methods: {
    loadData() {
      this.pageNo = 1;
      this.getIntServOrderList();
    },
    loadup() {
      if (this.allLoaded) {
        return;
      }
      this.pageNo++;
      this.getIntServOrderList();
    },
    toDetail(id) {
      this.$router.push(`/myAppointDetail?id=${id}`);
    },
    // 获取列表数据
    getIntServOrderList() {
      this.allLoaded = false;
      let params = {
        phone: this.common.userInfo.phone || this.common.userInfo.account,
        workerId: ""
      };
      getIntServOrderList(params).then(res => {
        util.hideLoading();
        console.log(res);
        if (res.res.code === 10000 && res.body) {
          if (res.body.intservOrders.length !== 10) {
            this.allLoaded = true;
          }
          if (this.pageNo === 1) {
            this.dataList = res.body.intservOrders;
          } else {
            this.dataList = [...this.dataList, ...res.body.intservOrders];
          }
        } else {
          // util.showToast(res.res.msg);
        }
        this.loaded = true;
      });
    },
  }
};
</script>
<style lang="less" scoped>
@import "../../assets/css/common.less";
.wrapper {
  background: #eee;
}
.news_box {
  height: 100vh;
  box-sizing: border-box;
  .list_item {
    position: relative;
    background: #fff;
    border-radius: 8px;
    margin: 20px;
    padding: 28px 20px;
    height:180px;
    box-sizing:border-box;
    display:flex;
    flex-direction: column;
    justify-content: space-between;
    .item_top {
      .flex();
      justify-content: space-between;
      height: 40px;
      margin-bottom: 10px;
      align-items: flex-start;
      .item_top_left {
        font-size: 28px;
        color: rgba(51, 51, 51, 1);
        line-height: 40px;
      }
      .item_top_right {
        height: 32px;
        font-size: 24px;
        color: rgba(255, 173, 93, 1);
        line-height: 32px;
      }
      .item_top_right_un{
        color:#999;
      }
    }
    .item_center {
      p {
        height: 40px;
        margin-bottom: 12px;
        font-size: 28px;
        color: rgba(51, 51, 51, 1);
        line-height: 40px;
        .textOver(100%);
      }
    }
    .item_bottom {
      .flex();
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      .item_bottom_left {
        font-size: 24px;
        color: rgba(153, 153, 153, 1);
      }
      .item_bottom_right {
        font-size: 28px;
        color: @colorfc;
      }
      .gray{
        color: rgba(153, 153, 153, 1);
      }
    }
  }
}
</style>
